import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Headline } from '@xingternal/typography';

type Props = {
  className?: string;
};

export const CultureTitle: React.FC<Props> = ({ className }) => {
  return (
    <Headline size="large" as="h4" className={className}>
      <FormattedMessage id="JOBS_DETAIL_COMPANY_CULTURE_TITLE" />
    </Headline>
  );
};
